import { Paper, PaperProps } from '@mui/material';
import { useWidgetTheme } from '@/context/WidgetThemeContext';

export function ThemedPaper({ sx, ...props }: PaperProps) {
  const { hasBackground } = useWidgetTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        ...(hasBackground && {
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
        }),
        ...sx,
      }}
      {...props}
    />
  );
}
